{
  "Binary": "Binary",
  "Calculation": "Calculation",
  "Compensation-Plan": "Comp. plan",
  "Create-Account": "Create account",
  "Dashboard": "Dashboard",
  "Document-Import": "Document import",
  "Document-Registry": "Document registry",
  "Entire-Network": "Entire network",
  "Finance-Payouts": "Payouts",
  "Finance-Transactions": "Transactions",
  "Finance-Wallet-Balances": "Wallet balances",
  "Finance-Wallet-Import": "Wallet import",
  "Finance": "Finance",
  "Genealogy": "Genealogy",
  "Import-Tree": "Import tree",
  "Logs": "Logs and reports",
  "Logs-Activity-Log": "Activity log",
  "Logs-Export-History": "Export history",
  "Logs-Reports": "Reports",
  "Manage-Accounts": "Manage accounts",
  "Manage-Accounts-Roles": "Roles",
  "Manage-Accounts-Accounts": "Accounts",
  "Marketing-Activity": "Marketing activity",
  "Network": "Network",
  "Payment-system": "Payment system",
  "Profile": "Profile",
  "Reports": "Reports",
  "Settings-Currencies": "Currencies",
  "Settings-Events": "Events",
  "Settings-Event-Settings": "Event settings",
  "Settings-Wallets": "Configure wallets",
  "Settings-Payout-Methods": "Configure payout methods",
  "Settings-Localization": "Localization",
  "Settings-Preferences": "Preferences",
  "Settings-Profile-Fields": "Configure profile fields",
  "Settings-Plan": "Configure plan settings",
  "Settings": "Settings",
  "Visual-Binary": "Visual binary",
  "Visual-Genealogy": "Visual genealogy",
  "Visual-Tree": "Visual tree",
  "Wallet": "Wallets",
  "Settings-Wallet-Transfer-Rules": "Configure wallet transfer rules",
  "periodTypes": {
    "monthly": "Monthly",
    "weekly": "Weekly",
    "daily": "Daily",
    "hourly": "Hourly",
    "quarterHourly": "Quarter hourly",
    "yearly": "Yearly"
  }
}
